import { Component } from "react"
import PropTypes from "prop-types"

import PopulatorInput from "partners/components/shared/field_type_inputs/populator_input"

const COLLECTION_SELECT_FIELD_TYPES = [
  {
    value: "dropdown_static",
    label: "Populate with list items specified here",
  },
  { value: "dropdown_dynamic", label: "Retrieve list items from my service" },
]

class CollectionSelectInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fieldTypeSlug: this.props.fieldTypeSlug,
      populator: this.props.populator,
    }
    this.props.updateField({ fieldTypeSlug: this.state.fieldTypeSlug })
  }

  updatePopulator = populator => {
    this.setState({ populator })
    this.props.updateField({ populator })
  }

  handleFieldTypeChange = event => {
    const fieldTypeSlug = event.target.value
    const populator =
      fieldTypeSlug === "dropdown_dynamic" ? [] : this.state.populator
    this.setState({ fieldTypeSlug })
    this.props.updateField({ fieldTypeSlug, populator })
  }

  render() {
    return (
      <>
        <div className="field">
          <div className="label">
            <label>Data source for dropdown list</label>
          </div>
          <div className="input">
            <select
              value={this.state.fieldTypeSlug}
              onChange={this.handleFieldTypeChange}
            >
              {COLLECTION_SELECT_FIELD_TYPES.map(i => (
                <option key={i.value} value={i.value}>
                  {i.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {this.state.fieldTypeSlug === "dropdown_dynamic" ? (
          <DynamicPopulatorView protocolUrl={this.props.protocolUrl} />
        ) : (
          <PopulatorInput
            onPopulatorChange={this.updatePopulator}
            populator={this.state.populator}
          />
        )}
      </>
    )
  }
}

const DynamicPopulatorView = ({ protocolUrl }) => {
  return (
    <div className="field">
      <label className="label">API endpoint to populate the dropdown</label>
      <div className="input">
        <input
          type="text"
          value={
            protocolUrl
              ? protocolUrl
              : "Please provide a key name for this field"
          }
          data-copy-field-on-click="API endpoint"
          disabled={!protocolUrl}
          readOnly
        />
      </div>
    </div>
  )
}

CollectionSelectInput.propTypes = {
  populator: PropTypes.array.isRequired,
  updateField: PropTypes.func.isRequired,
  fieldTypeSlug: PropTypes.string,
  protocolUrl: PropTypes.string,
}

CollectionSelectInput.defaultProps = {
  fieldTypeSlug: "dropdown_static",
}

export default CollectionSelectInput
